<template>
  <div class="panel__confirmation">
    <p class="panel__confirmation-title">
      {{ $t('feedback_panel.confirmation_step_title') }}
      <img :src="getEmojiImagePath(selectedRating.imageName)" class="panel__confirmation-emoji" alt />
    </p>
    <p class="panel__confirmation-text">{{ $t('feedback_panel.confirmation_step_text') }}</p>
    <p v-if="feedback && feedback.length" class="panel__confirmation-feedback">{{ feedback }}</p>
  </div>
</template>

<script>
import { getEmojiImagePath } from '@/lib/utils'

export default {
  name: 'Confirmation',
  props: {
    feedback: { type: String, default: null },
    selectedRating: { type: Object, required: true }
  },
  methods: {
    getEmojiImagePath
  }
}
</script>

<style>
.panel__confirmation {
  text-align: center;
}
.panel__confirmation-title .panel__confirmation-emoji {
  display: inline-block;
  vertical-align: middle;
}
.panel__confirmation-emoji {
  width: 25px;
  height: auto;
}
.panel__confirmation-text {
  font-size: 11px;
}
.panel__confirmation-feedback {
  margin-top: 10px;
  text-align: left;
  color: #666;
  padding-left: 7px;
  border-left: 3px solid #b9b9b9;
  font-size: 12px;
  font-style: italic;
}
</style>
